import { AxiosResponse } from "axios";
import api from "../utils/api";
import {
  ConvertProjectLeadDto,
  CreateProjectLeadDto,
  DiscardProjectLeadDto,
  ProjectLeadDto,
  UpdateProjectLeadDto,
} from "../types/projectLeadTypes";

/** API client for the Lead resource. */

/** Create a new Lead. */
export const createProjectLead = async (projectLead: CreateProjectLeadDto): Promise<AxiosResponse<ProjectLeadDto>> => {
  return await api.post<ProjectLeadDto>(`/leads`, projectLead);
};

/** Get all leads visible to the current user. */
export const getProjectLeads = async (): Promise<AxiosResponse<ProjectLeadDto[]>> => {
  return await api.get<ProjectLeadDto[]>(`/leads`);
};

/** Get a single lead by id. */
export const getProjectLeadById = async (leadId: number): Promise<AxiosResponse<ProjectLeadDto>> => {
  return await api.get<ProjectLeadDto>(`/leads/${leadId}`);
};

/** Update an existing lead. */
export const updateProjectLead = async (
  leadId: number,
  projectLead: UpdateProjectLeadDto
): Promise<AxiosResponse<ProjectLeadDto>> => {
  return await api.put<ProjectLeadDto>(`/leads/${leadId}`, projectLead);
};

/** Discard ("Lead verwerfen") — HoCR only. */
export const discardProjectLead = async (
  leadId: number,
  body: DiscardProjectLeadDto
): Promise<AxiosResponse<ProjectLeadDto>> => {
  return await api.post<ProjectLeadDto>(`/leads/${leadId}/discard`, body);
};

/** Convert ("Projekt ausschreiben") — HoCR only. */
export const convertProjectLead = async (
  leadId: number,
  body: ConvertProjectLeadDto
): Promise<AxiosResponse<{ leadId: number; projectId: number }>> => {
  return await api.post<{ leadId: number; projectId: number }>(`/leads/${leadId}/convert`, body);
};
